(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ShowPdfController', ShowPdfController);

    ShowPdfController.$inject = ['$state', '$uibModalInstance', 'content'];

    function ShowPdfController($state, $uibModalInstance, content) {
        var vm = this;

        vm.content = content;

        vm.clear = function () {
            $uibModalInstance.close();
        };
    }
})();
